import TrackPage from './TrackPage'

export default [{
	path: '/track/:id',
	component: TrackPage
}]



// WEBPACK FOOTER //
// ./src/pages/track/trackRoutes.js